import {Component} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'unauthorized-modal',
    template: require('./unauthorized.modal.html')
})

export class UnauthorizedModalComponent {
    constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/modals/unauthorized.modal.ts